<template>
    <div >
        <Loading :value="loading"></Loading>

        <!-- RACOURCIS -->
        <v-card>
           <!-- <v-tooltip top>
                <v-btn slot="activator" color="primary" @click.stop="newVeh()" dark>
                    Retour <v-icon center>back</v-icon>
                </v-btn>
                retourner dans le tableau de bord
            </v-tooltip> -->
            <v-card-title>
              <v-btn
              @click="
                $router.push({ name: 'ParcAuto', path: '/parc/auto' })
              "
              color="orange"
              dark
              ><v-icon left>keyboard_arrow_left</v-icon> Retour
            </v-btn>


                <!-- <v-breadcrumbs icons divider="chevron_right">
                    <v-breadcrumbs-item  icons router :to="item.path" v-for="item in racourcis" :key="item.text" :disabled="item.disabled">{{ item.text }} </v-breadcrumbs-item>
                </v-breadcrumbs> -->
            </v-card-title>
        </v-card>        
        <br>

        <!-- AFFICHEUR -->
        <v-container fluid grid-list-md text-xs-center>
          <v-layout row justify>
            <v-flex md3>
                <v-chip color="primary" text-color="white" style="font-size:20px; width:100%">
                    <v-avatar class="purple darken-4">{{nbVehTot}}</v-avatar> Véhicule(s)
                </v-chip>
            </v-flex>
            <v-flex md3>
                <v-chip color="green" text-color="white" style="font-size:20px; width:100%">
                    <v-avatar class="green darken-4">{{nbVehDisp}}</v-avatar> Disponible(s)
                </v-chip>
            </v-flex>
            <v-flex md3>
                <v-chip color="orange" text-color="white" style="font-size:20px; width:100%">
                    <v-avatar class="orange darken-4">{{nbVehUtil}}</v-avatar> En cours utilisation
                </v-chip>
            </v-flex>
            <v-flex md3>
                <v-chip color="blue-grey " text-color="white" style="font-size:20px; width:100%">
                    <v-avatar class="blue-grey  darken-4">{{nbVehRep}}</v-avatar> En réparation
                </v-chip>
            </v-flex>
              <v-flex md3>
                  <v-chip color="purple" text-color="white" style="font-size:20px; width:100%">
                      <v-avatar class="purple darken-4">{{nbVehLoc}}</v-avatar> En location
                  </v-chip>
              </v-flex>
            <v-flex md3>
                <v-chip color="red" text-color="white" style="font-size:20px; width:100%">
                    <v-avatar class="red darken-4">{{nbVehPan}}</v-avatar> En panne
                </v-chip>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- BTN AJOUT -->
        <v-spacer></v-spacer>
        <div class="text-xs-right mb-2">
            <v-tooltip top>
                <v-btn slot="activator" color="primary" @click.stop="newVeh()" dark>
                    Ajouter <v-icon center>add</v-icon>
                </v-btn>
                Ajouter un vehicule
            </v-tooltip>
        </div>

        <!-- MODAL AJOUT DE VEHICULE -->
        <v-dialog v-model="dialogAjoutVeh" :persistent="true" max-width="80%" :loading="loading">
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark color="primary">
                    <v-toolbar-title> <span>Ajouter /modifier d'un nouveau véhicule </span> </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="dialogAjoutVeh = false"> <v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-form id="formVehicule" ref="formVehicule"  v-model="valid" lazy-validation enctype='multipart/form-data'>
                        <v-stepper v-model="e1">
                            <v-stepper-header>
                                <v-stepper-step :complete="e1 > 1" step="1">Marque</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="e1 > 2" step="2">Générale</v-stepper-step>
                                <v-divider></v-divider>
                                <!-- <v-stepper-step :complete="e1 > 3" step="2">Etat de lieux d'entrée</v-stepper-step> -->
                            </v-stepper-header>

                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <!--Formulaire Marque-->
                                    <v-container fluid grid-list-md>
                                        <v-layout row>
                                            <v-flex md4>
                                                <v-layout row>
                                                    <v-flex md6>
                                                        <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="imageVeh" alt="avatar">
                                                        </v-avatar>
                                                        <v-layout row>
                                                            <input name="fichVeh" type="file" style="display:none" ref="fileVeh" accept="image/*" @change="onFileVehPicked"/>
                                                            <v-btn color="primary" class="white--text" required @click.native="$refs.fileVeh.click()">
                                                                Photo vehicule <v-icon right dark>cloud_upload</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex md6>
                                                        <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="imageCarteGris" alt="avatar">
                                                        </v-avatar>
                                                        <v-layout row>
                                                            <input name="fichCarteGris" type="file" style="display:none" ref="fileCarteGris" accept="image/*" @change="onFileCartePicked"/>
                                                            <v-btn color="primary" class="white--text" required @click.native=" $refs.fileCarteGris.click()">
                                                                Carte grise <v-icon right dark>cloud_upload</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex md8>
                                                <v-layout row>

                                                    <v-flex md6>
                                                        <div class="block">
                                                            <span class="demonstration">Catégorie de véhicule *</span>
                                                            <el-select allow-create   @change="chargeMarque" filterable clearable v-model="formVehicule.categorieId" placeholder="Catégorie de véhicule" style="width:100%">
                                                                <el-option v-for="item in listCategorie" :key="item.id" :label="item.libelle" :value="item.id">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </v-flex>

                                                    <v-flex md6>
                                                        <div class="block">
                                                            <span class="demonstration">Marque concerné *</span>
                                                            <el-select  allow-create @change="chargeModele" filterable clearable v-model="formVehicule.marqueId" placeholder="Marque concerné" style="width:100%">
                                                                <el-option v-for="item in listMarque" :key="item.id" :label="item.libelle" :value="item.id">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </v-flex>


                                                </v-layout>

                                                <v-layout row>

                                                    <v-flex md6>
                                                        <div class="block">
                                                            <span class="demonstration">Modèle concerné *</span>
                                                            <el-select allow-create  @change="chargeSerie" filterable clearable v-model="formVehicule.modeleId" placeholder="Modele concerné" style="width:100%">
                                                                <el-option v-for="item in listModele" :key="item.id" :label="item.libelle" :value="item.id">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                    </v-flex>

                                                    <v-flex md6>
                                                        <div class="block">
                                                          <span class="demonstration">Série du véhicule *</span>
                                                          <el-select  @change="selectSerie" allow-create filterable clearable v-model="formVehicule.serieId" placeholder="Série du véhicule" style="width:100%">
                                                            <el-option v-for="item in listSerie" :key="item.id" :label="item.libelle" :value="item.id">
                                                            </el-option>
                                                          </el-select>
                                                        </div>
                                                    </v-flex>






                                                </v-layout>

                                                <v-layout row>
                                                    <v-flex md6>
                                                        <div class="block">
                                                          <span class="demonstration">Immatriculation *</span>
                                                          <el-input name="matricule" placeholder="Immatriculation" v-model="formVehicule.matricule" required></el-input>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex md6>
                                                        <div class="block">
                                                          <span class="demonstration">N° du chassis *</span>
                                                          <el-input name="numChassis" placeholder="N° du chassis" v-model="formVehicule.numChassis" required></el-input>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>

                                                <v-layout row>
                                                    <v-flex md6>
                                                        <div class="block">
                                                          <span class="demonstration">N° de la carte grise *</span>
                                                          <el-input name="numCarteGris" placeholder="N° de la carte grise " v-model="formVehicule.numCarteGris" required></el-input>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <br>
                                    </v-container>

                                    <v-layout row>
                                        <v-btn icons color="orange" @click="dialogAjoutVeh = false" dark>Annuler <v-icon right>close</v-icon></v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click.native="e1 = 2"> Continuer <v-icon dark>navigate_next</v-icon> </v-btn>
                                    </v-layout>
                                </v-stepper-content>

                                <v-stepper-content step="2">
                                    <!--Formulaire Marque-->
                                    <v-container fluid grid-list-md>
                                        <v-layout row>
                                            <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Date d'acquisition *</span>
                                                    <el-date-picker value-format="dd-MM-yyyy" v-model="formVehicule.dateAqui" name="dateAqui" type="date" placeholder="Date d'acquisition" style="width:100%"></el-date-picker>
                                                </div>
                                            </v-flex>
                                            <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Type de carburant *</span>
                                                    <el-select filterable clearable v-model="formVehicule.typeCarbuId" placeholder="Type de carburant" style="width:100%">
                                                        <el-option v-for="item in typeCarburant" :key="item.id" :label="item.libelle" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                            </v-flex>
                                            <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Nombre de place *</span>
                                                    <el-input type="number" name="nbPlace" placeholder="Nombre de place" v-model="formVehicule.nbPlace" required></el-input>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row>
                                            <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Kilométrage Compteur (Km/h) *</span>
                                                    <el-input type="number" name="kilometrage" placeholder="Kilométrage (Km/h)" v-model="formVehicule.kilometrage" required></el-input>
                                                </div>
                                            </v-flex>
                                            <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Prix d'achat </span>
                                                    <el-input type="number" name="prixAchat" placeholder="Prix d'achat du vehicule " v-model="formVehicule.prixAchat" required></el-input>
                                                </div>
                                            </v-flex>
                                             <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Coût utilisation (par jour) </span>
                                                    <el-input type="number" name="coutUtil" placeholder="Cout d'utilisation du vehicule " v-model="formVehicule.coutUtil" required></el-input>
                                                </div>
                                            </v-flex>

                                        </v-layout>
                                        <v-layout row>
                                            <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Couleur *</span>
                                                    <el-input name="couleur" placeholder="Couleur" v-model="formVehicule.couleur" required></el-input>
                                                </div>
                                            </v-flex>
                                            <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Affecter un parc auto *</span>
                                                <el-select clearable allow-create filterable v-model="formVehicule.parcId" placeholder="Affecter un parc auto"    style="width:100%">
                                                        <el-option v-for="item in listParc" :key="item.id" :label="item.libelle" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                            </v-flex>
                                             <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Année du vehicule </span>
                                                    <el-date-picker value-format="yyyy" v-model="formVehicule.annVeh" name="annVeh"  type="year" placeholder="Année du vehicule" style="width:100%"></el-date-picker>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                        <br>
                                    </v-container>

                                    <v-layout row>
                                        <v-btn icons color="orange" @click="dialogAjoutVeh = false" dark>Annuler <v-icon right>close</v-icon></v-btn>
                                        <v-spacer></v-spacer>

                                        <v-btn dark color="primary" @click.native="e1 = 1"> <v-icon dark>navigate_before</v-icon> Précédent </v-btn>
                                        <v-btn color="primary"  :disabled="!formVehIsValid" @click.native="createVeh(idVehModif)">
                                            Enrregistrer <v-icon dark>save</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- MODAL SUPPRESSION MISSION-->
        <v-dialog v-model="dialogSuppVeh" width="40%" :overlay="true" scrollable persistent>
            <v-card>

                <v-card-title class="text-xs-center">
                    <h3 class="headline mb-0">Supprimer un vehicule</h3>

                    <v-flex xs12>
                        <v-alert outline color="orange darken-1" icon="warning" :value="true">
                            La suppression d'un vehicule est irréversible.
                        </v-alert>
                    </v-flex>
                </v-card-title>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="dialogSuppVeh = false">Annuler</v-btn>
                    <v-btn icons color="red" @click.stop="deleteVeh()" dark>Supprimer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- TABLEAU DE VEHICULE -->
        <el-card class="box-card">

                <v-layout row>
                   <v-flex md4 class="mr-1">
                          <el-select name="valeurSelect" id="valeurSelect"  clearable v-model="selectParc" v-on:change="loadTypeVehicule()" placeholder="Rechercher par parc auto" style="width:100%">
                              <el-option v-for="item in listParc" :key="item.id" :label="item.libelle" :value="item.id">
                              </el-option>
                          </el-select>
                      </v-flex>

                    <v-flex  xs9 class="mb-2">
                        <el-select @change="filtrerVehicule" v-model="selectEtatVeh" placeholder="Filtrer la liste">
                            <el-option
                                    v-for="item in comboEtatVeh"
                                    :key="item.etat"
                                    :label="item.label"
                                    :value="item.etat">
                            </el-option>
                        </el-select>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs2 class="text-xs-right">
                        <v-tooltip top>
                        <v-btn   slot="activator" color="green" :disabled="disabledBtnExc" @click.stop="imprimeExcFlotte(selectEtatVeh)" dark>
                            Imprimer Excel <v-icon >printer</v-icon>
                        </v-btn>
                            Imprimer la liste des vehicules
                        </v-tooltip>
                    </v-flex>

                    <v-flex xs2 class="text-xs-right">
                        <v-tooltip top>
                        <v-btn   slot="activator" color="orange" :disabled="disabledBtnExc" @click.stop="imprimeFlotte(selectEtatVeh)" dark>
                            Imprimer <v-icon >printer</v-icon>
                        </v-btn>
                            Imprimer la liste des vehicules
                        </v-tooltip>
                    </v-flex>
                </v-layout>

                <v-layout>

                <v-flex xs12 class="text-xs-right">
                    <v-tooltip bottom>
                        <v-btn class="elevation-3" slot="activator" @click="loadVehicule()" dark icon flat color="primary">
                            <v-icon>cached</v-icon>
                        </v-btn>
                        actualiser la liste
                    </v-tooltip>
                </v-flex>

                </v-layout>


            <data-tables :data="listVehicule" style="width: 100%">
               <el-table-column prop="parc" label="Parc">
                    <template slot-scope="scope">
                        <v-chip label text-color="white" color="primary">
                            {{ scope.row.parc }}
                        </v-chip>
                    </template>
                </el-table-column>
                <el-table-column prop="matricule" label="Immatriculation / Marque">
                    <template slot-scope="scope">
                        <v-chip label text-color="white" color="primary">
                            {{ scope.row.matricule }} / {{scope.row.marque}}<v-icon right>directions_car</v-icon>
                        </v-chip>
                    </template>
                </el-table-column>
                <el-table-column prop="marque" label="Modèle / Série">
                    <template slot-scope="scope">
                      <v-chip outline label text-color="primary" color="primary">
                        {{scope.row.modele}} / {{scope.row.serie}}
                      </v-chip>
                    </template>
                </el-table-column>
                <el-table-column prop="etat" label="Etat">
                    <template slot-scope="scope">
                        <v-chip v-if="scope.row.etat == 1" label text-color="white" color="green">
                            DISPONIBLE <v-icon>directions_bus</v-icon>
                        </v-chip>
                        <v-chip v-else-if="scope.row.etat == 2" label text-color="white" color="orange">
                            EN MISSION <v-icon>directions_bus</v-icon>
                        </v-chip>
                        <v-chip v-else-if="scope.row.etat == 3" label text-color="white" color="red">
                            EN PANNE <v-icon>directions_bus</v-icon>
                        </v-chip>
                        <v-chip v-else-if="scope.row.etat == 4" label text-color="white" color="red">
                            EN REPARATION <v-icon>directions_bus</v-icon>
                        </v-chip>
                        <v-chip v-else-if="scope.row.etat == 5" label text-color="white" color="purple">
                            EN LOCATION <v-icon>directions_bus</v-icon>
                        </v-chip>

                        <!--v-chip v-if="scope.row.assurnv === true" label text-color="white" color="red">
                            Assurance non-valide<v-icon>description</v-icon>
                        </v-chip>

                        <v-chip v-if="scope.row.assurAexp === true" label text-color="white" color="orange">
                            Assurance expire dans moins de 3 mois <v-icon>description</v-icon>
                        </v-chip>

                        <v-chip v-if="scope.row.visiteAbs === true" label text-color="white" color="red">
                            Visite technique non-valide<v-icon>description</v-icon>
                        </v-chip>

                        <v-chip v-if="scope.row.visiteExp === true" label text-color="white" color="orange">
                            Visite technique expire dans moins de 3 mois <v-icon>description</v-icon>
                        </v-chip>

                        <v-chip v-if="scope.row.vignetteAbs === true" label text-color="white" color="red">
                            Vignette non-valide<v-icon>description</v-icon>
                        </v-chip>

                        <v-chip v-if="scope.row.vignetteExp === true" label text-color="white" color="orange">
                            Vignette expire dans moins de 3 mois <v-icon>description</v-icon>
                        </v-chip -->

                    </template>
                </el-table-column>
                <el-table-column label="Action" width="200">
                    <template slot-scope="scope">
                      <div class="text-xs-center">
                        <v-tooltip top>
                          <v-btn slot="activator" @click="$router.push({name: 'FicheVehicule', params:{id: scope.row.idVeh}})" fab dark small color="green">
                            <v-icon dark>folder_open</v-icon>
                          </v-btn>
                          Détails
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn slot="activator" @click="editVeh(scope.row)" fab dark small color="primary">
                            <v-icon dark>edit</v-icon>
                          </v-btn>
                          Modifier
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn slot="activator" @click="confSuppVeh(scope.row)" fab dark small color="red">
                            <v-icon dark>delete</v-icon>
                          </v-btn>
                          Supprimer
                        </v-tooltip>
                      </div>
                    </template>
                </el-table-column>
            </data-tables>
        </el-card>

    </div>
</template>

<script>
    import Loading from '@/components/Loading'
    export default {
        components:{ Loading },
        name: "flotte",
        props: ["id"],
        data() {
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                loading: false,
                titleMessInfo: "",
                messTextInfo: "",
                typeMessInfo: "success",
                racourcis: [
                    {path: '/parc/auto', text: 'ParcAuto', disabled: false},
                    {path: '/', text: 'Flotte', disabled: false},
                ],
                //DATA VEHICULE
                nbVehTot: 0,
                nbVehDisp: 0,
                nbVehUtil: 0,
                paginationAssur: {},
                nbVehPan: 0,
                nbVehLoc: 0,
                nbVehRep: 0,
                dialogSuprVeh: false,
                idVehModif: "",
                titleModalAjout: "Ajouter un nouveau véhicule",
                libBtnAjoutVeh: "Ajouter un vehicule",
                valid: true,
                listVehicule: [],
                listMarque: [],
                listModele: [],
                listSerie: [],
                listParc: [],
                selectParc: '',
                listCategorie: [],
                formVehicule: {},
                e1: 0,
                dialogAjoutVeh: false,
                typeVeh: [],
                nameRules: [
                    v => !!v || 'Ce champs est requis',
                ],
                typeCarburant: [],
                imageCarteGris: "/static/img-doc.png",
                imageVeh: "/static/car_avatar.png",
                fileVeh: "",
                fileCarteGris: "",
                menuAnnVeh: "",
                dialogSuppVeh: false,
                msgLoad: "Chargement en cours",
                selectEtatVeh : 0,
                nbAssurAbs: 0,
                nbAssurAexp: 0,
                nbVisiteTechAbs: 0,
                nbVisiteTechExp: 0,
                nbVignetteAbs: 0,
                nbVignetteExp: 0,
                comboEtatVeh: [
                    {
                        etat:0,
                        label:"Vehicule"
                    },
                    {
                        etat:1,
                        label:"Vehicule Disponible"
                    },
                    {
                        etat:2,
                        label:"Vehicule en cours utilisation"
                    },
                    {
                        etat:3,
                        label:"Vehicule en panne"
                    },
                    {
                        etat:4,
                        label:"Vehicule en reparation"
                    },
                    {
                        etat:5,
                        label:"Vehicule en location"
                    }
                ],
                disabledBtnExc: false,

            }
        },
        computed: {
            formVehIsValid () {
                return this.formVehicule.marqueId != "" && this.formVehicule.modeleId != "" && this.formVehicule.serieId != ""  && this.formVehicule.matricule != null && this.formVehicule.numChassis != null  && this.formVehicule.numCarteGris  != null && this.formVehicule.typeCarbuId != null && this.formVehicule.kilometrage != null && this.formVehicule.parcId != null
            }
        },
        watch: {
        },
        methods: {
            chargeMarque(idCat){
                if(idCat != "" && !isNaN(idCat) ){
                    //chargement des modele lie a la categorie
                    this.loadMarque(idCat)
                }else {
                    this.formVehicule.marqueId = ''
                    this.listSerie = []
                    this.formVehicule.serieId = ''
                    this.formVehicule.modeleId = ''
                }
            },
            chargeModele(idMarq){
                if(idMarq != "" && !isNaN(idMarq)){
                    //chargement des modele lie a la categorie
                    this.loadModele(idMarq)
                }
                else {
                    this.listMarque.push({id:idMarq,libelle:idMarq,text:idMarq})
                }
            },
            chargeSerie(idMod){
                if(idMod != "" && !isNaN(idMod)){
                    //chargement des modele lie a la categorie
                    this.loadSerie(idMod)
                }
                else {
                    this.listModele.push({id:idMod,libelle:idMod,text:idMod})
                }
            },
            selectSerie(idSerie){
                if(idSerie != "" && !isNaN(idSerie)){

                } else {
                    this.listSerie.push({id:idSerie,libelle:idSerie,text:idSerie})
                }
            },
            filtrerVehicule(etat) {
                console.log("changement etat")
                this.loadVehiculeParEtat(etat)
            },
            newVeh () {
                this.formVehicule = {}
                this.dialogAjoutVeh = true
                this.imageCarteGris = "/static/img-doc.png"
                this.imageVeh = "/static/car_avatar.png"
                this.fileVeh = ""
                this.fileCarteGris = ""
            },
            editVeh (item) {
                this.loadMarque(item.categorieId)
                this.loadModele(item.marqueId)
                this.loadSerie(item.modeleId)
                console.log('item',item)
                this.formVehicule = item
                this.idVehModif = item.idVeh
                this.imageCarteGris = item.urlCarteGrise
                this.imageVeh = item.photoVeh
                this.dialogAjoutVeh= true
            },


            createVeh(idVehModif = "" )
            {
                this.loading = true

                if(this.formVehicule.marqueId == null || this.formVehicule.modeleId == null || this.formVehicule.serieId == null || this.formVehicule.categorieId == null ){
                    this.loading = false
                    this.$message.error("Veuillez renseigner correctement les champs categorie, marque, modele et serie")
                    return
                }

                if (this.$refs.formVehicule.validate()) {
                    var form = document.getElementById('formVehicule')
                    var data = new FormData(form)
                    let url = "";
                    if (idVehModif  !== "" && idVehModif !== undefined && idVehModif != null) {
                        url = this.domaine + 'parc/edit/vehicule/' + idVehModif
                    } else {
                        url = this.domaine + 'parc/new/vehicule'//WebServiceBundle:ParcAutoController:newVehicule
                    }

                    console.log("fromVehicule")
                    console.log(this.formVehicule)
                    data.append('idUser', this.user.id)
                    data.append('type', this.formVehicule.categorieId)
                    data.append('typeCarbu', this.formVehicule.typeCarbuId)
                    data.append('marque', this.formVehicule.marqueId)
                    data.append('modele', this.formVehicule.modeleId)
                    data.append('serie', this.formVehicule.serieId)
                    data.append('parc', this.formVehicule.parcId)
                    data.append('dateAqui', this.formVehicule.dateAqui)
                    data.append('annVeh', this.formVehicule.annVeh)
                    data.append('coutUtil', this.formVehicule.coutUtil)
                    data.append('matricule', this.formVehicule.matricule)
                    //data.append('prixAchat',this.formVehicule.prixAchat)




                    this.$http.post(url, data).then(response => {
                        if (response.body) {
                            this.loading = false
                            this.e1 = 1;
                            let verif = response.body
                            if (verif.code === 1)
                            {
                                this.$notify({
                                    title: 'ENREGISTREMENT REUSSI',
                                    message: "Véhicule enregistré avec succès.",
                                    type: 'success',
                                    position: 'top-right',
                                    duration: 5000
                                })
                                this.dialogAjoutVeh = false
                                //Reinitialisation des champs
                                this.$refs.formVehicule.reset()



                                this.$refs.fileCarteGris.value=""
                                this.$refs.fileVeh.value=""
                                this.imageCarteGris = "/static/car_avatar.png"
                                this.imageVeh = "/static/car_avatar.png"
                                this.imageCarteGris= "/static/car_avatar.png"
                                this.imageVeh= "/static/car_avatar.png"
                                this.loadVehicule()
                            } else if (verif.code === 0) {
                                this.$message.error(verif.message)
                                this.loading = false
                            } else if (verif.code === 5) {
                                this.loading = false
                                this.$message.error(verif.message)
                            }
                        } else {
                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                            this.loading = false
                        }
                    },
                    response => {
                        this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                        this.loading = false
                    })
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "Le véhicule n'a pas été enregistré.",
                        position: 'top-right'
                    })
                    this.loading = false
                    this.e1 = 1;
                }
            },


            loadMarque(idCat) {
                let url = this.domaine + 'parc/index/marque/cat/'+idCat
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listMarque = response.body.marque
                    }
                })
            },
            loadCategorie() {
                let url = this.domaine + 'parc/index/categorie'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listCategorie = response.body.categorie
                    }
                })
            },
            loadCarburant() {
                let url = this.domaine + 'parc/index/carburant'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.typeCarburant = response.body.carburant
                    }
                })
            },
            loadModele(idMarq) {
                let url = this.domaine + 'parc/index/modele/marque/'+idMarq
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listModele = response.body.modele
                    }
                })
            },
            loadSerie(idMod) {
                let url = this.domaine + 'parc/index/serie/modele/'+idMod
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listSerie = response.body.serie
                    }
                })
            },
            confSuppVeh(item) {
                this.idVehModif = item.idVeh
                this.dialogSuppVeh = true;
            },
            imprimeFlotte(idEtat = 0) {
                console.log("idetat")
                console.log(idEtat)
                let url = this.domaine + 'parc/impression/flotte/'+idEtat
                window.open(url)
            },
            imprimeExcFlotte(idEtat = 0) {
                let url = this.domaine + 'parc/impressionExc/flotte/'+idEtat
                window.open(url)
            },
            loadParc() {
                let url = this.domaine + 'parc/index/parc'
                this.$http.get(url).then(response => {
                    if (response.body) {
                       var tableau = response.body.parc;
                        for (var i = 0; i < tableau.length; ++i) {
                          for (var j = i + 1; j < tableau.length; ++j) {
                            if (tableau[i].libelle === tableau[j].libelle) {
                              tableau.splice(j--, 1);
                            }
                          }
                        }
                        this.listParc = tableau
                    }
                })
            },
             loadTypeVehicule(){
              this.loading = true;
              if(this.selectParc != 0){
                   let url = this.domaine + "parc/parcSelect/"+this.selectParc;
                this.$http.get(url).then(
                  response => {
                    this.loading = false;
                    this.listVehicule = response.body.listVehicule;
                  },
                  errRep => {
                    this.loading = false;
                    this.$message.error(
                      "Une erreur est survenue lors du chargement de la liste des vehicules"
                    );
                  }
                );
              }else{
                this.loadVehicule()
                this.loading = false;

              }


            },

            loadVehiculeParEtat(etat) {
                let url = this.domaine + 'parc/etat_veh'
                var data = new FormData()
                data.append("etat", etat)
                this.loading = true;

                this.$http.post(url,data).then(response => {
                    this.loading = false
                    if (response.body) {
                        this.listVehicule = response.body.vehicule
                        if (this.listVehicule === undefined || this.listVehicule.length == 0) {
                            this.disabledBtnExc = true
                        } else{
                          this.disabledBtnExc = false
                        }

                        this.nbVehTot = response.body.nbVeh
                        this.nbVehDisp = response.body.nbVehDisp
                        this.nbVehUtil = response.body.nbVehUtil
                        this.nbVehPan = response.body.nbVehPan
                        this.nbVehLoc = response.body.nbVehLoc
                        this.nbVehRep = response.body.nbVehRep
                    }
                },response => {
                    this.loading = false
                })
            },
            loadVehicule() {
              this.loading = true
                let url = this.domaine + 'parc/index'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listVehicule = response.body.vehicule
                        this.nbVehTot = response.body.nbVeh
                        this.nbVehDisp = response.body.nbVehDisp
                        this.nbVehUtil = response.body.nbVehUtil
                        this.nbVehPan = response.body.nbVehPan
                        this.nbVehLoc = response.body.nbVehLoc
                        this.nbVehRep = response.body.nbVehRep
                        this.nbAssurAbs = response.body.nbAssurAbs;
                        this.nbAssurAexp = response.body.nbAssurAexp;
                        this.nbVisiteTechAbs = response.body.nbVisiteTechAbs;
                        this.nbVisiteTechExp = response.body.nbVisiteTechExp;
                        this.nbVignetteAbs = response.body.nbVignetteAbs;
                        this.nbVignetteExp = response.body.nbVignetteExp;
                        this.loading = false
                        if (this.notif === 'active') {
                            if(response.body.mesAlert != "") {
                                this.$vs.notify({
                                    title:'NOTIFICATIONS VEHICULES',
                                    text: response.body.mesAlert,
                                    color:'warning',
                                    position:'top-right',
                                    time: 10000,
                                })
                            }

                            if(this.nbAssurAbs  != 0) {
                                 this.$vs.notify({
                                     title:'ASSURANCE NON-VALIDE',
                                     text: response.body.nbAssurAbs+ " vehicule(s) ne possede(nt) ou n'ont pas une assurance valide",
                                     color:'danger',
                                     position:'top-left',
                                     icon:'description',
                                     time: 10000
                                 })
                            }

                            if(this.nbAssurAexp  != 0) {
                                 this.$vs.notify({
                                     title:'EXPIRATION ASSURANCE',
                                     text: response.body.nbAssurAexp+ " assurance(s) vont expirer dans moins de 3 mois",
                                     color:'warning',
                                     position:'top-left',
                                     icon:'description',
                                     time: 10000
                                 })
                            }

                            if(this.nbVisiteTechAbs  != 0) {
                                 this.$vs.notify({
                                     title:'VISITE TECHNIQUE NON-VALIDE',
                                     text: response.body.nbVisiteTechAbs+ " vehicule(s) ne possede(nt) ou n'ont pas une visite technique valide",
                                     color:'danger',
                                     position:'top-left',
                                     icon:'description',
                                     time: 10000
                                 })
                            }

                            if(this.nbVisiteTechExp  != 0) {
                                 this.$vs.notify({
                                     title:'EXPIRATION VISITE TECHNIQUE',
                                     text: response.body.nbVisiteTechExp+ " visite(s)  technique vont expirer dans moins de  3 mois",
                                     color:'warning',
                                     position:'top-left',
                                     icon:'description',
                                     time: 10000
                                 })
                            }

                            if(this.nbVignetteAbs  != 0) {
                                 this.$vs.notify({
                                     title:'VIGNETTE NON-VALIDE',
                                     text: response.body.nbVignetteAbs+ " vehicule(s) ne possede(nt) ou n'ont pas une vignette valide",
                                     color:'danger',
                                     position:'top-left',
                                     icon:'description',
                                     time: 10000
                                 })
                            }

                            if(this.nbVignetteExp != 0) {
                                 this.$vs.notify({
                                     title:' EXPIRATION VIGNETTE',
                                     text: response.body.nbVignetteExp+ " vignettes(s) vont expirer dans moins de 3 mois",
                                     color:'warning',
                                     position:'top-left',
                                     icon:'description',
                                     time: 10000
                                 })
                            }
                        }

                    }
                })
            },
            deleteVeh() {
                this.loading = true;
                let url = this.domaine + "parc/vehicule/delete/" + this.idVehModif;
                this.$http.get(url).then(
                    response => {
                        if (response.body) {
                            this.loading = false;
                            this.$notify({
                                title: "SUPPRESSION",
                                message: "Le vehicule a été  supprimé avec succès.",
                                type: "success",
                                position: "top-right",
                                duration: 5000
                            });
                            this.dialogSuppVeh = false;
                            this.idVehModif = null;
                            this.loadVehicule();
                        }
                    },
                    response => {
                        this.dialogSuppVeh = false;
                        this.$message.error(
                            "Erreur,Veuillez supprimer d'abord l'assurance, la vidange, la visite technique de cet véhicule"
                        );
                        this.loading = false;
                    }
                );
            },
            onFileCartePicked(event) {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }
                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.imageCarteGris = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.fileCarteGris = files[0]
            },

            onFileVehPicked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.imageVeh = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.fileVeh = files[0]
            }
        },
        mounted() {
            this.loadCategorie()
            this.loadCarburant()
            this.loadParc()
            if(this.$route.params.etat_veh == undefined || this.$route.params.etat_veh == 0 ){
                this.loadVehicule()
            } else{
                this.selectEtatVeh = this.$route.params.etat_veh
                this.loadVehiculeParEtat(this.$route.params.etat_veh)
            }





        }
    };
</script>

<style scoped>
  .box-card {
    width: 100%;
  }

  .breadcrumbs__item--disabled {
      pointer-events: all;
  }
</style>



// WEBPACK FOOTER //
// src/components/Flotte.vue